import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'assets/scss/prime-table.scss';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Button from '@material-ui/core/Button';
import { FaTimes } from 'react-icons/fa';
import { InputNumber } from 'primereact/inputnumber';
import { dominioBackend } from '../../config/database';
import 'assets/css/minhas-requisicoes.css';
import listaUnidadesDeMedida from '../../utils/listaUnidadesDeMedida';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: '10px',
    marginBottom: '20px',
    width: '12vw',
    height: '2vh',
  },
  autoComplete: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: '10px',
    marginBottom: '20px',
    width: '42vw',
  },
}));

export default function CorpoRequisicao({
  setListaProdutosSelecionados,
  produtosSelecionados,
  exibirInformacaoAdicionalProduto = false,
}) {
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [listaProdutos, setListaProdutos] = useState([]);
  const [carregandoListaProdutos, setCarregandoListaProdutos] = useState(false);
  const [first, setFirst] = useState();
  const classes = useStyles();

  useEffect(() => {
    setCarregandoListaProdutos(true);
    dominioBackend.get(`/api/produtos`).then(
      res => {
        setListaProdutos(res.data);
        setCarregandoListaProdutos(false);
      },
      () => {
        setCarregandoListaProdutos(false);
      }
    );

    setListaProdutosSelecionados(produtosSelecionados);
  }, []);

  function handleClickAdicionaProduto(event) {
    event.preventDefault();

    if (produtoSelecionado !== null) {
      setListaProdutosSelecionados([
        ...produtosSelecionados,
        {
          idProduto: produtoSelecionado.id,
          nome: produtoSelecionado.nome,
          quantidadeRequisitada: 1,
          informacaoAdicional: null,
          unidade: {
            valor: 'und',
            nome: 'Unidade',
          },
          valor: produtoSelecionado.valor,
        },
      ]);

      setProdutoSelecionado(null);
    }
  }

  function produtoBodyTemplate(rowData) {
    return (
      <>
        <span>{rowData.nome}</span>
      </>
    );
  }

  function handleExcluirProduto(rowData) {
    setListaProdutosSelecionados(
      produtosSelecionados.filter(obj => {
        return obj.idProduto !== rowData.idProduto;
      })
    );
  }

  const onQuantidadeRequisitadaChange = (rowData, value) => {
    const produtos = produtosSelecionados;
    const produtoIndex = produtos.findIndex(p => p.idProduto === rowData.idProduto);
    produtos[produtoIndex].quantidadeRequisitada = value ?? null;
    setListaProdutosSelecionados(produtos);
  };

  const quantidadeRequisitadaEditor = props => {
    return (
      <InputNumber
        value={props.rowData.quantidadeRequisitada}
        onChange={e => onQuantidadeRequisitadaChange(props.rowData, e.value)}
        min={1}
        max={5000}
      />
    );
  };

  const quantidadeRequisitadaBodyTemplate = rowData => {
    return (
      <InputNumber
        required
        value={rowData.quantidadeRequisitada}
        onChange={e => onQuantidadeRequisitadaChange(rowData, e.value)}
        min={1}
        max={5000}
      />
    );
  };

  const onInformacaoAdicionalChange = (rowData, value) => {
    setListaProdutosSelecionados(prev =>
      prev.map(produto =>
        produto === rowData
          ? { ...produto, informacaoAdicional: value.slice(0, 30) || null }
          : produto
      )
    );
  };

  const informacaoAdicionalBodyTemplate = rowData => (
    <TextField
      label="Informação adicional"
      value={rowData.informacaoAdicional ?? ''}
      onChange={e => onInformacaoAdicionalChange(rowData, e.target.value)}
      inputProps={{ maxLength: 30 }}
      variant="outlined"
      size="small"
      fullWidth
    />
  );

  const onUnidadeMedidaChange = (rowData, value) => {
    setListaProdutosSelecionados(prev => {
      const listaProdutosAtualizada = prev.map(p =>
        p.idProduto === rowData.idProduto ? { ...p, unidade: value || null } : p
      );
      return listaProdutosAtualizada;
    });
  };

  const getProdutoAtualizado = idProduto =>
    produtosSelecionados.find(p => p.idProduto === idProduto);

  const unidadeItemTemplate = option => (
    <div>
      {option ? (
        <>
          <strong>{option.valor}</strong>
          {' - '}
          {option.nome}
        </>
      ) : (
        ''
      )}
    </div>
  );

  const unidadeMedidaBodyTemplate = rowData => {
    return (
      <Dropdown
        value={getProdutoAtualizado(rowData.idProduto)?.unidade || null}
        options={listaUnidadesDeMedida}
        onChange={e => onUnidadeMedidaChange(rowData, e.value)}
        itemTemplate={unidadeItemTemplate}
        optionLabel="valor"
        placeholder="Selecione"
        style={{ width: '150px' }}
      />
    );
  };

  function excluirBodyTemplate(rowData) {
    return (
      <IconButton
        color="secondary"
        onClick={() => handleExcluirProduto(rowData)}
        style={{
          backgroundColor: 'red',
        }}
      >
        <FaTimes color="white" size={11} />
      </IconButton>
    );
  }

  return (
    <form onSubmit={handleClickAdicionaProduto}>
      <div className={classes.root}>
        <Autocomplete
          id="produtoID"
          options={listaProdutos}
          getOptionLabel={option => `${option.codigo} - ${option.nome}`}
          loading={carregandoListaProdutos}
          loadingText="Carregando..."
          className={classes.autoComplete}
          value={produtoSelecionado}
          onChange={(e, value) => {
            setProdutoSelecionado(value);
          }}
          renderInput={params => (
            <TextField {...params} required label="Produto" variant="outlined" />
          )}
        />
        <Button
          color="primary"
          aria-label="Adiciona Produto"
          size="small"
          type="submit"
          variant="contained"
          className="botao-adicionar"
        >
          <AddIcon size={14} />
        </Button>
      </div>
      <div className={classes.root}>
        <DataTable
          value={produtosSelecionados}
          paginator
          rows={4}
          emptyMessage="Nenhum produto selecionado"
          first={first}
          className="p-datatable-prime"
          onPage={e => {
            setFirst(e.first);
          }}
        >
          <Column
            field="produto"
            header="Produto"
            body={produtoBodyTemplate}
            headerStyle={{ width: '15vw' }}
          />
          {exibirInformacaoAdicionalProduto && (
            <Column
              field="informacaoAdicional"
              header="Informação adicional"
              body={informacaoAdicionalBodyTemplate}
              headerStyle={{ width: '12vw' }}
            />
          )}
          <Column
            field="quantidade"
            header="Quantidade"
            body={quantidadeRequisitadaBodyTemplate}
            editor={quantidadeRequisitadaEditor}
            headerStyle={{ width: '7vw' }}
          />
          <Column
            field="unidade"
            header="Unidade de medida"
            body={unidadeMedidaBodyTemplate}
            headerStyle={{ width: '7vw' }}
          />
          <Column
            field="acoes"
            header="Ações"
            body={excluirBodyTemplate}
            headerStyle={{ width: '7vw' }}
          />
        </DataTable>
      </div>
      <br />
    </form>
  );
}
